/* mg-video v1: compact player modal for site videos. Nothing loads until play. Exitable: close button, Esc, backdrop click. */
(function(){
  if (window.mgVideo) return;
  var modal, vid, title, cr, last;
  function build(){
    modal = document.createElement('div');
    modal.className = 'mgv-modal'; modal.hidden = true;
    modal.setAttribute('role','dialog'); modal.setAttribute('aria-modal','true'); modal.setAttribute('aria-labelledby','mgvModalT');
    modal.innerHTML = '<div class="mgv-box"><div class="mgv-bar"><p class="mgv-bar-t" id="mgvModalT"></p><button type="button" class="mgv-x" aria-label="Close video">&times;</button></div><video controls playsinline preload="none"></video><p class="mgv-modal-cr" hidden></p></div>';
    document.body.appendChild(modal);
    vid = modal.querySelector('video'); title = modal.querySelector('.mgv-bar-t'); cr = modal.querySelector('.mgv-modal-cr');
    modal.querySelector('.mgv-x').addEventListener('click', close);
    modal.addEventListener('click', function(e){ if (e.target === modal) close(); });
    modal.addEventListener('keydown', function(e){
      if (e.key === 'Tab') { var x = modal.querySelector('.mgv-x'); if (document.activeElement === x && !e.shiftKey) { e.preventDefault(); vid.focus(); } else if (document.activeElement === vid && e.shiftKey) { e.preventDefault(); x.focus(); } }
    });
  }
  function open(el){
    var src = el.getAttribute('data-src'); if (!src) return false;
    if (!modal) build();
    last = el;
    title.textContent = el.getAttribute('data-title') || '';
    var c = el.getAttribute('data-credits') || ''; cr.textContent = c; cr.hidden = !c;
    vid.poster = el.getAttribute('data-poster') || '';
    vid.src = src;
    modal.hidden = false; document.documentElement.classList.add('mgv-lock');
    modal.querySelector('.mgv-x').focus();
    var p = vid.play(); if (p && p.catch) p.catch(function(){});
    return true;
  }
  function close(){
    if (!modal || modal.hidden) return;
    vid.pause(); vid.removeAttribute('src'); vid.load();
    modal.hidden = true; document.documentElement.classList.remove('mgv-lock');
    if (last && last.focus) last.focus();
  }
  document.addEventListener('click', function(e){
    var el = e.target.closest && e.target.closest('[data-mgv-open]');
    if (el && open(el)) e.preventDefault();
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
  window.mgVideo = { open: open, close: close };
})();
